// src/components/About.jsx
function About() {
    return (
      <div className="about">
        <h2>About Page</h2>
        <p>Ini adalah aplikasi React sederhana dengan dua halaman.</p>
        <button onClick={() => alert('Tentang aplikasi ini')}>Info</button>
      </div>
    );
  }
  
  export default About;